var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('b-spinner',{staticClass:"mb-2",attrs:{"label":"Loading...","variant":"info","size":"lg"}}),(_vm.label)?_c('p',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }